export const deleteAccount = {
  deleteAccountTitle: "Versoek om jou Randrush-rekening te verwyder",
  deleteAccountContent: "As jy jou Randrush-rekening wil verwyder, stuur asseblief 'n e-pos aan",
  deleteAccountInfo: "Ons span sal ongeveer 24 uur neem om jou versoek op te los.",
  deleteAccountInfo2:
    "Wanneer die rekening verwyder word, sal alle inligting wat met jou rekening verband hou permanent uitgevee word en jy sal nie weer jou rekening kan gebruik nie.",
};
